import {
  message,
  PageHeader,
  Spin,
  Select,
  Row,
  Col,
  Upload,
  Tooltip,
  Space
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  ButtonItem,
  ErrorItem,
  SelectInsumosItem,
  BarcodeScanner,
  TextAreaItem,
  DatePickerItem,
  round10Decimals,
  DynamicCardForm,
  TabbedDynamicTable
} from "../../../../Components/Items";

import { PlusOutlined, DeleteOutlined, FileExcelOutlined, UploadOutlined, CalculatorOutlined, CommentOutlined,ContainerOutlined} from "@ant-design/icons";
import VistaPrevia from "../VistaPrevia/VistaPrevia";
import ElegirObservaciones from "../../Ventas/ElegirObservaciones/ElegirObservaciones";
import moment from "moment";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import * as XLSX from 'xlsx'

const { Option } = Select;

class TraspasoEntreAlmacenes extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    todasInsumos: [],
    objetoInsumos: null,
    modalVistaPrevia: false,
    modalVistaPreviaId: null,
  };
  componentDidMount() {
    this.barcodeScanner = new BarcodeScanner({
      onScan: this.leerCodigo.bind(this),
      minScanLength: 4,
      scanGapMs: 25,
      fastKeysToArm: 3,
      idleTimeoutMs: 80,
      preventScanWhenLoading: true,
      getLoadingState: () => this.state.loading
    });

    this.consultarTodo?.().then(() => this.precargarDesdeState());
  }

  precargarDesdeState() {
    const precarga = this.props.location?.state;
    if (!precarga) return;

    this.ordenDeProduccionPUIdPrecarga = precarga.ordenDeProduccionPUId;

    const insumosPrecarga = precarga.insumos?.length > 0
      ? precarga.insumos
      : precarga.insumoId
        ? [{ insumoId: precarga.insumoId, cantidad: precarga.cantidad || 1, clave: precarga.clave, descripcion: precarga.descripcion }]
        : [];

    if (insumosPrecarga.length === 0) return;

    if (precarga.proyectoOrigenId) {
      this.formRef.current.setFieldsValue({
        proyectoOrigenId: precarga.proyectoOrigenId,
        proyectoDestinoId: precarga.proyectoDestinoId,
        observaciones: precarga.observaciones,
        insumos: insumosPrecarga.map((insumo) => ({ insumoId: insumo.insumoId, cantidad: insumo.cantidad || 1 })),
      });
      insumosPrecarga.forEach((insumo, index) => {
        this.onChangeInsumo(null, index, { _id: insumo.insumoId, clave: insumo.clave, descripcion: insumo.descripcion });
      });
    } else {
      this.formRef.current.setFieldsValue({ proyectoDestinoId: precarga.proyectoDestinoId, observaciones: precarga.observaciones });
      message.info("Elige de qué proyecto traspasar y agrega el insumo faltante manualmente.");
    }
  }

  componentWillUnmount() {
    this.barcodeScanner?.destroy();
  }



  async leerCodigo(codigo) {
    const proyectoOrigen = this.formRef.current.getFieldValue("proyectoOrigenId");
    const proyectoDestino = this.formRef.current.getFieldValue("proyectoDestinoId");
    if (!proyectoOrigen || !proyectoDestino) {
      return message.warning("Primero llene los datos principales");
    }
    let insumo

    if (Array.isArray(this.state.todasInsumos)) {
      const insumoPrecargado = this.state.todasInsumos.find(i => i.codigoBarras === codigo);
      if (insumoPrecargado) {
        insumo = insumoPrecargado;
      }
    }

    if (!insumo) {
      await axios.post(
        "insumos/obtenerInsumoPorCodigoInventariables",
        {
          codigoBarras: codigo,
          proyectoId: proyectoOrigen,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
        .then(res => {
          if (res.data && res.data.success === 2 && res.data.insumo) {
            insumo = res.data.insumo;
            message.success(`Producto "${insumo.stringBuscar}" encontrado`);
          } else {
            message.error('Producto no encontrado');
          }
        })
        .catch(error => {
          console.error("Error al buscar insumo:", error);
          message.error('Error al buscar producto');
        });
    }
    if (!insumo) {
      return message.warning("No encontramos el producto");
    }
    const insumosEnTraspaso = this.formRef.current.getFieldValue("insumos") || [];
    const indexInsumoEnTraspaso = insumosEnTraspaso.findIndex((todosInsumosVenta) => {
      if (todosInsumosVenta.insumoId) {
        return (
          todosInsumosVenta?.insumoId?.toString() ===
          insumo._id.toString()
        );
      } else {
        return false;
      }
    })
    if (indexInsumoEnTraspaso === -1) {
      const indexInsumoEnTraspasoSinInsumo = insumosEnTraspaso.findIndex((todosInsumosVenta) => {
        return !todosInsumosVenta?.insumoId && !todosInsumosVenta?.precioUnitario && !todosInsumosVenta?.cantidad;
      })
      if (indexInsumoEnTraspasoSinInsumo !== -1) {
        const insumosConNuevaCantidad = [...insumosEnTraspaso];
        insumosConNuevaCantidad[indexInsumoEnTraspasoSinInsumo].insumoId = insumo._id?.toString();
        insumosConNuevaCantidad[indexInsumoEnTraspasoSinInsumo].cantidad = 1;
        this.formRef.current.setFieldsValue({
          insumos: insumosConNuevaCantidad,
        });
        this.onChangeInsumo(null, indexInsumoEnTraspasoSinInsumo, insumo);
      } else {
        const nuevosInsumos = [
          ...insumosEnTraspaso,
          { insumoId: insumo._id?.toString(), cantidad: 1 }
        ];
        this.formRef.current.setFieldsValue({
          insumos: nuevosInsumos,
        });
        this.onChangeInsumo(null, insumosEnTraspaso.length, insumo);
      }
    } else {
      const insumosConNuevaCantidad = [...insumosEnTraspaso];
      insumosConNuevaCantidad[indexInsumoEnTraspaso].cantidad =
        insumosConNuevaCantidad[indexInsumoEnTraspaso].cantidad + 1;
      this.formRef.current.setFieldsValue({
        insumos: insumosConNuevaCantidad,
      });
      this.onChangeInsumo(null, indexInsumoEnTraspaso, insumo);
    }
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "empleados/selectEmpleados",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasEmpleados: res.data,
            objetoEmpleados: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " " + (value.apellidoPaterno || "") + " " + (value.apellidoMaterno || "")}
                </Option>
              );
            }),
          });
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "traspasoEntreAlmacenes/traspasoEntreAlmacenes",
        {
          ...values,
          empresaId: this.props.empresaId,
          ordenDeProduccionPUId: this.ordenDeProduccionPUIdPrecarga,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se ha traspasado el inventario"
          );
          NotificacionPolizas(res.data.polizasId)
          NotificacionMovimientosInventario(res.data.movimientosIds)
          this.setState({
            modalVistaPrevia: true,
            modalVistaPreviaId: res.data.traspasoId,
          });
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se puede traspasar el inventario");
        } else {
          message.error("Hubo un error y el inventario no se traspaso");
        }
      });
  }
  onChangeProyectoOrigenPrecarga = async () => {
    const insumos = this.formRef.current.getFieldValue("insumos") || [];
    for (let index = 0; index < insumos.length; index++) {
      if (insumos[index]?.insumoId) {
        await this.onChangeInsumo(null, index, null);
      }
    }
  };

  async onChangeInsumo(value, key, insumoEncontrado) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proyectoOrigen = await this.formRef.current.getFieldValue("proyectoOrigenId");
    this.setState({ loading: true });
    const insumoId = arrayValue[key].insumoId;
    let insumo
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
      if (!yaExiste) {
        await this.setState(prev => ({
          todasInsumos: [...prev.todasInsumos, insumo]
        }));
      }
    } else {
      insumo = this.state.todasInsumos.find(
        (valueInsumos) => valueInsumos._id === insumoId
      );
    }
    this.setState({ loading: false });
    if (!insumo) return
    await axios
      .post(
        "inventarios/inventarioInsumoProyecto",
        {
          proyectoId: proyectoOrigen,
          insumoId: insumoId,
          noPrincipal: insumo.noPrincipal,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        arrayValue[key].cantidadProyecto = res.data.cantidad;
      });
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  cerrarVistaPrevia() {
    this.setState({
      modalVistaPrevia: false,
      modalVistaPreviaId: null,
    });
    this.formRef.current.resetFields();
    this.atras();
  }
  abrirObservaciones(value, observaciones, insumoId) {
    const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoId.toString())
    this.setState({
      modalObservaciones: true,
      modalObservacionesIndex: value,
      modalObservacionesObservaciones: observaciones,
      modalObservacionesObservacionesPasadas: insumo?.observacionesPasadas
    })
  }
  cerrarObservaciones(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalObservacionesIndex].observaciones = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalObservaciones: false,
      modalObservacionesIndex: null,
      modalObservacionesObservaciones: null,
      modalObservacionesObservacionesPasadas: null,
    })
  }
  abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
    if (proyectoId) {
      this.setState({
        modalElegirLotes: true,
        modalElegirLotesIndex: value,
        modalElegirLotesLotes: lotes || [],
        modalElegirLotesInsumoId: insumoId,
        modalElegirLotesProyectoId: proyectoId,
        modalElegirLotesCantidad: cantidad,
      })
    } else {
      message.warning('Elegir un proyecto para elegir lotes')
    }
  }
  cerrarElegirLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirLotesIndex].lotes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirLotes: false,
      modalElegirLotesIndex: null,
      modalElegirLotesLotes: null,
      modalElegirLotesInsumoId: null,
      modalElegirLotesProyectoId: null,
      modalElegirLotesCantidad: null,
    })
  }
  async descargarExcel() {
    this.setState({ loading: true });
    const response = await fetch('/plantillaAgregarInventario.xlsx'); // asegÃºrate de que estÃ© en la carpeta "public"
    const data = await response.arrayBuffer();
    let plantillaXlsx = XLSX.read(data, { type: "array" });


    // Guardar el archivo modificado
    XLSX.writeFile(plantillaXlsx, "plantillaAgregarInventario.xlsx");
    this.setState({ loading: false });

  }

  async descargarExcelCI() {
    this.setState({ loading: true });
    const response = await fetch('/plantillaAgregarInventario.xlsx'); // asegÃºrate de que estÃ© en la carpeta "public"
    const data = await response.arrayBuffer();
    let plantillaXlsx = XLSX.read(data, { type: "array" });

    let hojaInsumos

    try {
      const responseInsumos = await axios.post(
        "insumos/selectInsumosInventariablesRaw",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )


      if (responseInsumos.data.success === 2) {
        // Crear una nueva hoja con dato
        hojaInsumos = responseInsumos.data.insumos.map((insumo) => {
          return {
            "Clave": insumo.clave,
            "Descripcion": insumo.descripcion,
          }
        })
        this.setState({ todasInsumos: responseInsumos.data.insumos });
      }

    } catch (err) {
      console.error(err);
    }

    if (hojaInsumos) {
      const nuevaHojaInsumos = XLSX.utils.json_to_sheet(hojaInsumos);

      // Agregar la nueva hoja al workbook
      XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaInsumos, "Insumos");
    }



    // Guardar el archivo modificado
    XLSX.writeFile(plantillaXlsx, "plantillaAgregarInventario.xlsx");

    this.setState({ loading: false });

  }

  async onChangeArchivo(e) {
    this.setState({ loading: true })
    await this.formRef.current.validateFields().then(() => {
      if (e.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.setState({ archivosExcel: [{ ...e.file, name: e.file.name, status: 'uploading', response: 'Cargando', }], archivo: e.file });
        this.cargarArchivoExcel(e.file)
      } else {
        message.error('El archivo debe ser un archivo de excel')
        this.setState({ loading: false })
      }
    }).catch((error) => {
      message.error('Complete los campos requeridos antes de cargar el archivo')
      this.setState({ loading: false })
    })
  }

  cargarArchivoExcel(file) {
    let hojas = [];
    let reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onloadend = (e) => {
      let data = new Uint8Array(e.target.result)
      let workbook = XLSX.read(data, { type: 'array' })

      workbook.SheetNames.forEach((sheetName) => {
        let Xl_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
        hojas.push({
          data: Xl_row_object,
          sheetName
        })
      })
      let hoja1 = hojas[0].data
      this.archivoVerificar(hoja1).then((dataReturn) => {
        if (dataReturn.errores === 0) {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success' }] });
          this.formRef.current.setFieldsValue({
            insumos: dataReturn.objeto,
          })
          dataReturn.objeto.forEach((insumo, index) => {
            this.onChangeInsumo(null, index, null);
          })
        } else {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success', response: 'Con errores', }], archivoError: dataReturn.archivoErrores });
          this.formRef.current.setFieldsValue({
            insumos: dataReturn.objeto,
          })
          dataReturn.objeto.forEach((insumo, index) => {
            this.onChangeInsumo(null, index, null);
          })
          message.error('Se han detectado ' + dataReturn.errores + ' errores')
          message.info('Se se importan solo se importaran los campos correctos: ' + Number(hoja1.length - dataReturn.filaErrores))
        }
        this.setState({ loading: false })
      })
    }
  }

  async archivoVerificar(data) {
    let errores = 0
    let filaErrores = 0
    let mensaje = []
    const archivoEditar = XLSX.utils.book_new()
    const arrayErrores = []
    let objeto = []

    if (this.state.todasInsumos.length === 0) {
      try {
        const responseInsumos = await axios.post(
          "insumos/selectInsumosInventariablesRaw",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )


        if (responseInsumos.data.success === 2) {
          // Crear una nueva hoja con datos
          await this.setState({ todasInsumos: responseInsumos.data.insumos });
        }

      } catch (err) {
        console.error(err);
      }
    }

    await Promise.all(data.map(async (data, index) => {
      let mensajeErrores = null
      let erroresFila = 0
      let fila = data['__rowNum__'] + 1
      let clave = data['Clave'] ? `${data['Clave']}`.trim() : undefined
      let codigoBarras = data['CÃ³digo de barras '] ? `${data['CÃ³digo de barras ']}`.trim() : undefined
      let descripcion = data['Descripcion'] ? `${data['Descripcion']}`.trim() : undefined
      let cantidad = data['Cantidad'] ? `${data['Cantidad']}`.trim() : undefined
      const checarQueSeaNumero = (valor, nombreCampo) => {
        if (valor !== '' && valor !== undefined) {
          if (isNaN(valor) === true) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es un numero`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un numero` : `${nombreCampo} no es un numero`
          }
        }
      }
      const queEste = (valor, nombreCampo) => {
        if (valor === '' || valor === undefined) {
          errores += 1
          erroresFila += 1
          mensaje.push(`${nombreCampo} fila: ${fila} esta vacio`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} esta vacio` : `${nombreCampo} esta vacio`
        }
      }
      const queSeaStringValido = (valor, nombreCampo) => {
        const patron = /^[A-Za-z0-9\n.: ,"'Â´`Â¨=Ã¸$#Â°ÂºÂªÃ¡ÃÃ©Ã‰Ã­ÃÃ³Ã“ÃºÃšÃ¼ÃœÃ±Ã‘@_/*+%&()!-_{Â¼Â³\u00A0]*$/
        if (valor !== '' && valor !== undefined) {
          if (!patron.test(valor)) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es un valor acceptado`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un valor acceptado` : `${nombreCampo} no es un valor acceptado`
          }
        }
      }
      queEste(clave, 'Clave')
      queEste(descripcion, 'Descripcion')
      queSeaStringValido(clave, 'Clave')
      queSeaStringValido(descripcion, 'Descripcion')
      queSeaStringValido(codigoBarras, 'CÃ³digo de barras ')
      checarQueSeaNumero(cantidad, 'Cantidad')

      let insumoId

      const encontrarInsumo = this.state.todasInsumos.find((value) => value.clave === clave && (value.descripcion === descripcion || value.codigoBarras === codigoBarras))
      if (!encontrarInsumo) {
        errores += 1
        erroresFila += 1
        mensaje.push(`Insumo fila: ${fila} no existe`)
        mensajeErrores = mensajeErrores ? mensajeErrores + `, Insumo no existe` : `Insumo no existe`
      } else {
        insumoId = encontrarInsumo._id
      }

      if (erroresFila === 0) {
        objeto.push({
          cantidad: Number(cantidad),
          insumoId: insumoId,
        })
      } else {
        arrayErrores.push({
          'Errores': mensajeErrores,
          'Fila archivo inicial': fila,
          ...data,
        })
        filaErrores += 1
      }
      return null
    }))
    const hoja = XLSX.utils.json_to_sheet(arrayErrores)
    XLSX.utils.book_append_sheet(archivoEditar, hoja, 'Hoja Errores')
    return { objeto: objeto, errores: errores, filaErrores, mensaje: mensaje, archivoErrores: archivoEditar }
  }

  descargarArchivoErrores() {
    let wbout = XLSX.write(this.state.archivoError, { bookType: 'xlsx', type: 'binary' });
    const s2ab = (s) => {
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf);  //create uint8array as viewer
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
      return buf;
    }
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" })
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'errores.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
  }
  setMaxEntregarTodos = () => {
    const form = this.formRef?.current; // ajusta si tu ref se llama distinto
    if (!form) return;

    const insumos = form.getFieldValue("insumos") || [];

    const nuevos = insumos.map((row, idx) => {
      const cantidadProyecto = Number(row?.cantidadProyecto) || 0;

      const minPermitido = round10Decimals(cantidadProyecto);

      if (minPermitido > 0) {
        return {
          ...row,
          cantidad: minPermitido > 0 ? minPermitido : undefined,
        };
      } else {
        return row;
      }

    });

    form.setFieldsValue({ insumos: nuevos });
  };
  render() {
    const isMobile = window.innerWidth <= 1000;

    const allTabs = [
      {
        key: 'insumos',
        label: 'Insumos',
        listName: 'insumos',
        columns: [
          { title: 'Insumo', width: '50%' },
          { title: 'Cantidad Proyecto', width: '15%' },
          {
            title: (
              <>
                Cantidad
                <Tooltip title='Poner maximos.'>
                  <CalculatorOutlined onClick={this.setMaxEntregarTodos} style={{ marginLeft: '5px', color: 'green' }} />
                </Tooltip>
              </>
            ),
            width: '15%',
          },
          { title: 'Acción', width: '15%' },
        ],
        renderRow: ({ key, name, restField, arrayKey, remove }) => (
          <React.Fragment key={key}>
            <tr>
              <td className="td-border">
                <FormItem
                  {...restField}
                  name={[name, "insumoId"]}
                  fieldKey={[arrayKey, "insumoId"]}
                  required
                  noStyle
                >
                  <SelectInsumosItem
                    empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                    headersToken={this.props.headersToken}
                    sinBorde
                    autoFocus
                    dropdownMatchSelectWidth={600}
                    width="100%"
                    placeholder="Insumo"
                    tiposInsumos="inventariablesConEquivalencias"
                    onChange={(value, insumoEncontrado) =>
                      this.onChangeInsumo(
                        value,
                        arrayKey,
                        insumoEncontrado
                      )
                    }
                  />
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem
                  {...restField}
                  name={[name, "cantidadProyecto"]}
                  fieldKey={[arrayKey, "cantidadProyecto"]}
                  number
                  noStyle
                  required
                  initialValue={undefined}
                >
                  <InputNumberItem sinBorde disabled />
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem
                  noStyle
                  shouldUpdate={(prev, curr) =>
                    prev.insumos[arrayKey]?.cantidadProyecto !==
                    curr.insumos[arrayKey]?.cantidadProyecto
                  }
                >
                  {({ getFieldValue }) => {
                    const insumos = getFieldValue("insumos");
                    if (!insumos[arrayKey]) return
                    const cantidadProyecto =
                      insumos[arrayKey].cantidadProyecto;
                    let max = cantidadProyecto;
                    return (
                      <FormItem
                        {...restField}
                        name={[name, "cantidad"]}
                        fieldKey={[arrayKey, "cantidad"]}
                        number
                        noStyle
                        required
                        max={max}
                        type='number'
                        initialValue={undefined}
                      >
                        <InputNumberItem sinBorde />
                      </FormItem>
                    );
                  }}
                </FormItem>
              </td>
              <td className="td-border-sin-right">
                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    let arrayValue = getFieldValue("insumos");
                    const proyectoOrigenId = getFieldValue("proyectoOrigenId");
                    let buttons = [];
                    let mostrarLotes = false
                    let insumoId
                    if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                      const insumo = this.state.todasInsumos.find(
                        (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                      );
                      insumoId = insumo?._id
                      mostrarLotes = insumo?.lotesCaducidades
                    }
                    if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                      buttons.push(
                       <Tooltip title="Agregar Observaciones" placement="top" overlayInnerStyle={{fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                          <ButtonItem
                            type="primary"
                            size='small'
                            cyan2
                            icon={<CommentOutlined />}
                          verde={arrayValue[arrayKey]?.observaciones}
                          onClick={() => {
                            this.abrirObservaciones(arrayKey, arrayValue[arrayKey]?.observaciones, arrayValue[arrayKey]?.insumoId, arrayValue[arrayKey].observacionesXml)
                          }}
                        >
                        </ButtonItem>
                      </Tooltip>
                      )
                    }
                    if (mostrarLotes) {
                      buttons.push(
                         <Tooltip title={this.props.taxidermia ? "Animales" : "Lotes"} placement="top" overlayInnerStyle={{fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                          <ButtonItem
                            type="primary"
                            size='small'
                            amarillo2
                            icon={<ContainerOutlined />}
                          onClick={() => {
                             this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoOrigenId, arrayValue[arrayKey].cantidad)
                          }}
                        >
                        </ButtonItem>
                      </Tooltip>
                      )
                    }

                    return (
                      <div className="acciones-container">
                          <Space style={{ width: '100%', gap: 5, justifyContent: 'center' }}>
                          {buttons}
                           <ButtonItem
                              key="remove"
                              rojo2
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                              size="small"
                              lessTime
                            />

                          </Space>
                      </div>
                    );
                  }}
                </FormItem>
              </td>
            </tr>
            <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos[arrayKey]?.observaciones !== curr.insumos[arrayKey]?.observaciones}>
              {({ getFieldValue }) => {
              let arrayValue = getFieldValue("insumos");
              if (arrayValue && arrayValue[arrayKey]?.observaciones) {
                return (
                  <tr className="fila-observaciones">
                    <td colSpan="10" className="td-border-sin-right">
                      <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', backgroundColor: arrayValue[arrayKey].observacionesXml ? '#dceeffff' : 'white' }}>
                        <div style={{ width: '100%', textAlign: 'left', paddingLeft: 25, color: "#036572"}}>
                          {String(arrayValue[arrayKey].observaciones)
                            .split(/\r?\n/)
                            .map((line, i) => <span key={i}>{line}<br /></span>)}
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              }
            }}
            </FormItem>
          </React.Fragment>
        ),
        renderFooter: ({ add, fields }) => (
          <FormItem
            noStyle
            shouldUpdate={(prev, curr) =>
              prev.proyectoOrigenId !== curr.proyectoOrigenId
            }
          >
            {({ getFieldValue }) => {
              const proyectoOrigen = getFieldValue("proyectoOrigenId");
              return (
                <FormItem noStyle>
                  <div style={{ marginBottom: 6, marginTop: 6 }}>
                    <ButtonItem
                      type="dashed"
                      hotkey="alt+a"
                      cyan
                      block
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        justifySelf: fields.length > 0 ? "left" : null,
                        width: fields.length > 0 ? "auto" : null,
                      }}
                      onClick={
                        proyectoOrigen
                          ? () => add()
                          : () =>
                            message.info(
                              "Agregue el proyecto origen primero"
                            )
                      }
                      icon={<PlusOutlined />}
                    >
                      Agregar Campo
                    </ButtonItem>
                  </div>
                </FormItem>
              );
            }}
          </FormItem>
        ),
      },
    ];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Traspaso Entre Almacenes"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <ButtonItem
              type="primary"
              key="descargarExcel"
              icon={<FileExcelOutlined />}
              onClick={this.descargarExcelCI.bind(this)}
              verde
            >
              Plantilla
            </ButtonItem>,
            this.state.archivoError ? <ButtonItem onClick={this.descargarArchivoErrores.bind(this)} danger>Descargar Errores</ButtonItem> : null,
            <Upload
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={this.state.archivosExcel}
              customRequest={this.onChangeArchivo.bind(this)}
              accept='.xlsx'
            >
              <ButtonItem icon={<UploadOutlined />}>Subir Excel</ButtonItem>
            </Upload>,
          ]}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="traspasoEntreAlmacenes"
              layout
              bottom={
              <div className="general-form-action-buttons">
                  <ButtonItem
                    type="primary"
                    hotkey="shift+a"
                    cyanB
                    htmlType="submit"
                  >
                    Traspasar
                  </ButtonItem>
              </div>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
            <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
              <Col xs={24} xl={12}>
                <DynamicCardForm
                  title="DATOS GENERALES"
                  style={{ margin: 0, height: '100%' }}
                >
                  <Row>
                    <Col span={24}>
                      <FormItem
                        label="Fecha de Traspaso"
                        name="fechaTraspaso"
                        margin
                        initialValue={moment()}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 14 }}
                      >
                        <DatePickerItem
                          placeholder="Fecha de Traspaso"
                          allowClear={false}
                          dateFormat='DD/MM/YYYY'
                        />
                      </FormItem>
                    </Col>
                    <Col span={24}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const insumos = getFieldValue('insumos')
                          const disabled = insumos?.length > 0 && !this.ordenDeProduccionPUIdPrecarga
                          return (
                            <FormItem label="Proyecto Origen" name="proyectoOrigenId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                              <SelectItem
                                placeholder="Proyecto Origen"
                                disabled={disabled}
                                onChange={this.ordenDeProduccionPUIdPrecarga ? this.onChangeProyectoOrigenPrecarga : undefined}
                              >
                                {this.state.objetoProyectos}
                              </SelectItem>
                            </FormItem>
                          )
                        }}
                      </FormItem>
                    </Col>
                    <Col span={24}>
                      <FormItem label="Proyecto Destino" name="proyectoDestinoId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                        <SelectItem placeholder="Proyecto Destino" disabled={!!this.ordenDeProduccionPUIdPrecarga}>
                          {this.state.objetoProyectos}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={24}>
                      <FormItem
                        pattern
                        name='observaciones'
                        label='Observaciones'
                        margin
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 14 }}
                      >
                        <TextAreaItem />
                      </FormItem>
                    </Col>
                  </Row>
                </DynamicCardForm>
              </Col>
              <Col xs={24} xl={12}>
                <DynamicCardForm
                  title="EMPLEADOS"
                  style={{ margin: 0, height: '100%' }}
                >
                  <Row>
                    <Col span={24}>
                      <FormItem label="Gestor" name="empleadoGestorId" margin labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                        <SelectItem placeholder="Gestor">
                          {this.state.objetoEmpleados}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={24}>
                      <FormItem label="Residente" name="empleadoResidenteId" margin labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                        <SelectItem placeholder="Residente">
                          {this.state.objetoEmpleados}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={24}>
                      <FormItem label="Autorizo" name="empleadoAutorizoId" margin labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                        <SelectItem placeholder="Autorizo">
                          {this.state.objetoEmpleados}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={24}>
                      <FormItem label="Conformidad" name="empleadoConformidadId" margin labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                        <SelectItem placeholder="Conformidad">
                          {this.state.objetoEmpleados}
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </DynamicCardForm>
              </Col>
            </Row>
            <div style={{ marginTop: 40 }}>
              <TabbedDynamicTable
                formInstance={this.formRef}
                defaultActiveKey="insumos"
                isMobile={isMobile}
                tabs={allTabs}
              />
            </div>
            </Form>
          </Spin>
        </div>
        <VistaPrevia
          visible={this.state.modalVistaPrevia}
          id={this.state.modalVistaPreviaId}
          cerrarVistaPrevia={this.cerrarVistaPrevia.bind(this)}
        />
        <ElegirObservaciones
          visible={this.state.modalObservaciones}
          cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)}
          observaciones={this.state.modalObservacionesObservaciones}
          observacionesPasadas={this.state.modalObservacionesObservacionesPasadas}
          observacionesXml={this.state.modalObservacionesObservacionesXml}
          noXml
        />
        <ElegirLotes
          visible={this.state.modalElegirLotes}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
          lotes={this.state.modalElegirLotesLotes}
          insumoId={this.state.modalElegirLotesInsumoId}
          proyectoId={this.state.modalElegirLotesProyectoId}
          cantidad={this.state.modalElegirLotesCantidad}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(TraspasoEntreAlmacenes);
